import React from 'react'
import { AnalyticsBrowser } from '@segment/analytics-next'
import { IReportsSegmentRepository, TSegmentDownloadEvent, TSegmentUpdateEvent } from 'domain/repositories/reports-segment-repository'

export type TSegmentProviderState = {
  segment: AnalyticsBrowser
  segmentUpdateEvent: (segmentUpdateRequestParams : TSegmentUpdateEvent) => void;
  segmentDownloadEvent: (segmentDownloadEvent : TSegmentDownloadEvent) => void;
}

export const initialState: TSegmentProviderState = {
  segment: AnalyticsBrowser.load({ writeKey: process.env.REACT_APP_SEGMENT_KEY || '' }),
  segmentUpdateEvent: () => null,
  segmentDownloadEvent: () => null,
}

export type TSegmentProviderProps = {
  reportsSegmentDatasource: IReportsSegmentRepository;
  children: JSX.Element;
}

export const SegmentContext = React.createContext<TSegmentProviderState>(initialState)

export const SegmentProvider = ({
  reportsSegmentDatasource,
  children
}: TSegmentProviderProps) => {

  const segmentUpdateEvent = (segmentUpdateRequestParams : TSegmentUpdateEvent) => { 
    reportsSegmentDatasource
      .dashboardUpdateEvent(segmentUpdateRequestParams);
  }

  const segmentDownloadEvent = (segmentDownloadEvent : TSegmentDownloadEvent) => {
    reportsSegmentDatasource
      .downloadEvent(segmentDownloadEvent);
  }

  return (
    <SegmentContext.Provider 
      value={{
        ...initialState,
        segmentUpdateEvent,
        segmentDownloadEvent
      }}
    >
      {children}
    </SegmentContext.Provider>
  )
}